<template>
  <a-form-model
    ref="product-form"
    :rules="rules"
    :model="productForm"
    v-bind="layout"
  >
    <a-form-model-item
      :label="$t('priority.company')"
      prop="company"
      has-feedback
    >
      <a-select
        v-model="productForm.company"
        show-search
        option-filter-prop="children"
        :filter-option="filterOption"
        @change="handleCompanySelect(true)"
      >
        <a-select-option
          v-for="_company in companyList"
          :key="_company.id"
          :value="_company.id"
        >
          {{ $l(_company.name) }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item
      :label="$t('priority.product')"
      prop="product"
      has-feedback
    >
      <a-select
        v-model="productForm.product"
        show-search
        :loading="loading"
        :filter-option="false"
        :default-active-first-option="false"
        :show-arrow="false"
        :not-found-content="loading ? undefined : null"
        :disabled="!productForm.company"
        @search="handleSearch"
      >
        <a-spin
          v-if="loading"
          slot="notFoundContent"
          size="small"
        />
        <a-select-option
          v-for="_product in productList"
          :key="_product.id"
          :value="_product.id"
        >
          {{ $l(_product.name) }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item
      :label="$t('priority.value')"
      prop="priority"
      has-feedback
    >
      <a-select
        v-model="productForm.priority"
      >
        <a-select-option
          v-for="value in priorityMaxValue"
          :key="value"
          :value="value"
        >
          {{ value }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item
      :wrapper-col="{span: 24, offset: 20}"
    >
      <a-button
        :loading="loading"
        type="primary"
        @click="submitForm('product-form')"
      >
        {{ form.id ? $t('common.save') : $t('common.send') }}
      </a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>

export default {
  name: 'PriorityProductForm',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({
        priority: null,
        product: null,
      }),
    },
    companyList: {
      type: Array,
      default: () => [],
    },
    productList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      priorityMaxValue: 15,
      layout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      },
      productForm: {
        company: null,
        priority: null,
        product: null,
      },
    }
  },

  computed: {
    rules() {
      return {
        company: [{
          validator: this.validateNull,
          trigger: 'change',
        }],
        priority: [{
          validator: this.validateNull,
          trigger: 'change',
        }],
        product: [{
          validator: this.validateNull,
          trigger: 'change',
        }],
      }
    },
  },

  watch: {
    form: {
      handler(newVal) {
        this.productForm = {
          id: newVal.id,
          company: newVal.company,
          priority: newVal.priority,
          product: newVal.product,
        }

        if (this.form.company) {
          this.handleCompanySelect(false)
        }
      },
      immediate: true,
    },
  },

  methods: {
    validateNull(rule, value, callback) {
      if (value === null) {
        callback(new Error(this.$t('common.required')))
      } else {
        callback()
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$emit('submit', this.productForm)
        } else {
          return false
        }
      })
    },

    handleSearch(value) {
      this.$emit('onSearch', value)
    },

    handleCompanySelect(resetProduct) {
      if (resetProduct) {
        this.productForm.product = null
      }
      this.$emit('companySelect', this.productForm.company)
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
  },
}
</script>

<style scoped>
.location-wrapper {
  display: flex;
  justify-content: space-evenly;
}

.work-time-wrapper {
  display: flex;
  justify-content: start;
}
</style>
